export let Roles = /*#__PURE__*/function (Roles) {
  // eslint-disable-next-line no-unused-vars
  Roles["Admin"] = "Admin";
  return Roles;
}({});
export default {
  [Roles.Admin]: 'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJleHAiOjUwMDM5MTEwNjUsImlhdCI6MTY0MzkxMDc2NSwic3ViIjoiYWRtaW4iLCJuYmYiOjE2NDM5MTA3NjUsImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3Q6ODAwMCIsImlzcyI6Imh0dHA6Ly9sb2NhbGhvc3Q6ODAwMCJ9.oQCmryoO5dMDUe1qsm97XMJojheK1UQc7sxToviNNS0N3cLRDmnEyawcDOGskLEopaPfSStR-c9woqLkQKaKhg'
};